"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import posthog from "posthog-js";

/**
 * Fires a single PostHog `page_not_found` event when a not-found boundary
 * renders.
 *
 * Critical for visibility: Next's App Router serves notFound() during
 * client-side (soft) navigation as an HTTP 200 RSC response, so soft 404s
 * never appear in status-code-based logging (Vercel runtime logs, alerts).
 * This client island captures the attempted path regardless of hard vs
 * soft navigation, so missing/moved URLs surface in analytics.
 *
 * posthog-js no-ops silently when NEXT_PUBLIC_POSTHOG_KEY is missing, so
 * this is safe on local dev and PR previews.
 */
export function NotFoundTracker() {
  const pathname = usePathname();
  useEffect(() => {
    try {
      posthog.capture("page_not_found", { path: pathname });
    } catch (err) {
      console.error("[not-found-tracker] posthog capture failed", { err });
    }
  }, [pathname]);

  return null;
}
